import { createClient } from '@supabase/supabase-js';
import { env } from './env.js';

/**
 * Cliente Supabase.
 *
 * `persistSession` e `autoRefreshToken` ligados de proposito: a equipe entra uma
 * vez no escritorio e passa quatro dias sem rede. Isso significa que um token de
 * longa duracao fica no dispositivo — dai o PIN local exigido pelo plano, que e
 * uma camada separada desta.
 */
export const supabase = createClient(env.supabaseUrl, env.supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    storageKey: 'equiview.auth',
  },
  global: {
    headers: { 'x-equiview-version': env.appVersion },
  },
});
